export default __webpack_public_path__ + "static/media/testing-center.9ac792ae.jpg";